import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("vf-token") || "");
  const [user, setUser] = useState(null);
  const [membership, setMembership] = useState(null); // {membership: "active"|"free", plan, expires_at, pending}
  const [loading, setLoading] = useState(!!localStorage.getItem("vf-token"));

  const refreshMembership = async (tkn) => {
    const t = tkn || token;
    if (!t) { setMembership(null); return; }
    try {
      const { data } = await axios.get(`${API}/membership/status`, { headers: { Authorization: `Bearer ${t}` } });
      setMembership(data);
    } catch {
      setMembership(null);
    }
  };

  useEffect(() => {
    if (!token) {
      setUser(null);
      setMembership(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    axios
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setUser(data))
      .catch(() => {
        localStorage.removeItem("vf-token");
        setToken("");
        setUser(null);
      })
      .finally(() => setLoading(false));
    refreshMembership(token);
  }, [token]);

  const save = (data) => {
    localStorage.setItem("vf-token", data.token);
    setToken(data.token);
    setUser({ name: data.name, email: data.email, role: data.role });
  };

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    save(data);
    return data;
  };

  const register = async (name, email, password, extra = {}) => {
    const { data } = await axios.post(`${API}/auth/register`, { name, email, password, ...extra });
    save(data);
  };

  const refreshUser = async () => {
    if (!token) return;
    const { data } = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
    setUser(data);
  };

  const logout = () => {
    localStorage.removeItem("vf-token");
    setToken("");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ token, user, loading, login, register, logout, refreshUser, membership, refreshMembership }}>
      {children}
    </AuthContext.Provider>
  );
}
